"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var attendance_exports = {};
__export(attendance_exports, {
  getMeetingAttendanceId: () => getMeetingAttendanceId,
  recordMeetingAttendance: () => recordMeetingAttendance
});
module.exports = __toCommonJS(attendance_exports);
var import_core = __toESM(require("@hcengineering/core"));
var import_plugin = __toESM(require("./plugin"));
var import_types = require("./types");
function getMeetingAttendanceId(meeting, person) {
  return `${meeting}_${person}`;
}
__name(getMeetingAttendanceId, "getMeetingAttendanceId");
async function recordMeetingAttendance(client, room, person, joinedOn = Date.now()) {
  const meeting = await client.findOne(import_plugin.default.class.MeetingMinutes, {
    attachedTo: room._id,
    status: import_types.MeetingStatus.Active
  });
  if (meeting === void 0) return void 0;
  const _id = getMeetingAttendanceId(meeting._id, person);
  const existing = await client.findOne(import_plugin.default.class.MeetingAttendance, { _id });
  if (existing !== void 0) return _id;
  await client.createDoc(
    import_plugin.default.class.MeetingAttendance,
    import_core.default.space.Workspace,
    {
      attachedTo: meeting._id,
      attachedToClass: import_plugin.default.class.MeetingMinutes,
      collection: "attendance",
      person,
      room: room._id,
      joinedOn
    },
    _id
  );
  return _id;
}
__name(recordMeetingAttendance, "recordMeetingAttendance");
//# sourceMappingURL=attendance.js.map
